export const newsList = [
  {
    id: "news-1",
    type: "news",
    title: "《星轨彼端》第二季正式定档，全新预告公开",
    summary:
      "官方于今日公布《星轨彼端》第二季将于下季度开播，并放出长达九十秒的全新预告，主角弦月与观测站成员将迎来更宏大的星海篇章。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20starry%20night%20sky%20with%20glowing%20constellations%20and%20a%20young%20girl%20silhouette%20gazing%20upward%2C%20deep%20blue%20and%20gold%20tones%2C%20cinematic%20anime%20key%20visual%2C%20detailed%20digital%20illustration&width=800&height=500&seq=news-01&orientation=landscape",
    category: "新番情报",
    tags: ["星轨彼端", "新番", "科幻"],
    date: "2026-10-12",
    author: "星野编辑",
    popularity: 96,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "定档信息与播出安排",
        paragraphs: [
          "官方今日晚间在直播发布会上正式公布，《星轨彼端》第二季将于下季度每周五深夜档播出，全季共十二集。同步公开的主视觉图中，主角弦月站在观测站穹顶之下，身后是延展开来的星轨。",
          "本次发布会还确认了首集将采用长达四十分钟的加长版，制作委员会表示希望用更充足的篇幅交代新篇章的世界观转折。",
        ],
      },
      {
        id: "s2",
        heading: "全新预告片的看点",
        paragraphs: [
          "九十秒预告中出现了三处此前未曝光的场景：深海中的数据方舟、悬浮于轨道之上的环城，以及以碎片形态登场的旧日观测员。画面节奏明显快于第一季，动作分镜更为凌厉。",
          "配乐方面依旧由原班音乐团队负责，主题曲则邀请到曾操刀多部科幻动画的创作歌手演唱，预告结尾已放出副歌片段。",
        ],
      },
      {
        id: "s3",
        heading: "制作阵容与观众期待",
        paragraphs: [
          "导演在采访中透露，第二季将把叙事重心从“寻找”转向“选择”，主角团每个人都需要面对一次无法回避的决断。系列构成也由原作者参与监修，力求还原漫画关键桥段。",
          "消息公布后，相关话题迅速登上多个平台热搜，粉丝普遍对预告中的作画质量表示认可，同时也期待旧角色的回归。",
        ],
      },
    ],
  },
  {
    id: "news-2",
    type: "news",
    title: "《深海夜航》剧场版首周票房刷新年度纪录",
    summary:
      "《深海夜航》剧场版上映首周便取得亮眼成绩，成为本年度开局表现最好的动画电影之一，官方同步宣布将追加限定场次。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20submarine%20gliding%20through%20deep%20ocean%20with%20bioluminescent%20lights%2C%20moody%20teal%20and%20navy%20palette%2C%20cinematic%20anime%20film%20key%20visual&width=800&height=500&seq=news-02&orientation=landscape",
    category: "剧场版",
    tags: ["深海夜航", "剧场版", "票房"],
    date: "2026-10-10",
    author: "海蓝编辑",
    popularity: 92,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "开局表现",
        paragraphs: [
          "《深海夜航》剧场版于上周五正式公映，首周票房表现超出业内预期，成为本年度同类作品中最亮眼的开局之一。影院的黄金场次几乎场场满座。",
          "发行方表示，观众的年龄结构比预想中更广，除了原作粉丝，也有大量被预告吸引而来的新观众。",
        ],
      },
      {
        id: "s2",
        heading: "影片口碑",
        paragraphs: [
          "影评普遍称赞本作在视听层面的大胆尝试，尤其是深海场景的音效设计与光影处理，被认为达到了系列新高。剧情的完成度也收获了较高评价。",
          "也有观众提出结尾节奏略显仓促，但整体评价仍以正面为主。",
        ],
      },
      {
        id: "s3",
        heading: "追加场次与新动向",
        paragraphs: [
          "为回应观众热情，发行方宣布将在全国范围内追加限定场次，并推出附赠特典的特别放映。",
          "同时官方暗示，系列后续的企划正在筹备之中，具体信息将于年末公布。",
        ],
      },
    ],
  },
  {
    id: "news-3",
    type: "news",
    title: "原创动画《光界旅人》宣布制作决定",
    summary:
      "由新锐工作室主导的原创动画《光界旅人》正式公布，将以“在光与影交界处旅行”为核心概念，预计明年与观众见面。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20traveler%20walking%20on%20a%20path%20of%20light%20between%20worlds%2C%20surreal%20glowing%20landscape%2C%20warm%20amber%20and%20deep%20blue%2C%20original%20anime%20key%20visual&width=800&height=500&seq=news-03&orientation=landscape",
    category: "新作企划",
    tags: ["光界旅人", "原创动画", "新作"],
    date: "2026-10-08",
    author: "星野编辑",
    popularity: 84,
    format: "",
    region: "日本",
    year: "2027",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "企划概览",
        paragraphs: [
          "新锐工作室今日公布原创动画企划《光界旅人》，作品将以“在光与影交界处旅行”为核心概念，讲述一位旅人穿越不同光界寻找答案的故事。",
          "官方强调本作不做原作改编，是完全原创的长篇企划，力求在美术与叙事上同时做出突破。",
        ],
      },
      {
        id: "s2",
        heading: "创作理念",
        paragraphs: [
          "导演表示，灵感来自对“边界”这一意象的长期思考，希望用光的明暗变化来呈现人物内心的抉择。",
          "团队还将邀请不同领域的艺术家参与场景设计，让每个光界拥有独立的视觉语言。",
        ],
      },
      {
        id: "s3",
        heading: "后续安排",
        paragraphs: [
          "目前企划处于前期制作阶段，官方预计于明年公开首支正式预告与播出档期。",
          "制作组承诺将保持高质量作画，并逐步放出角色设定与世界观资料。",
        ],
      },
    ],
  },
  {
    id: "news-4",
    type: "news",
    title: "漫画《樱花武斗》累计发行突破五百万册",
    summary:
      "热血漫画《樱花武斗》官方宣布累计发行量突破五百万册，为庆祝这一里程碑，将推出全新绘制纪念封面与限定周边。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20martial%20artist%20girl%20under%20falling%20cherry%20blossoms%20holding%20a%20wooden%20sword%2C%20dynamic%20action%20pose%2C%20pink%20petals%20and%20blue%20sky%2C%20manga%20cover%20illustration&width=800&height=500&seq=news-04&orientation=landscape",
    category: "漫画",
    tags: ["樱花武斗", "漫画", "里程碑"],
    date: "2026-10-06",
    author: "小林编辑",
    popularity: 88,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "里程碑达成",
        paragraphs: [
          "连载方今日宣布，《樱花武斗》漫画累计发行量正式突破五百万册，这一数字包含单行本与电子版的合计销量。",
          "作品自连载以来凭借扎实的武打分镜与细腻的人物成长获得广泛好评，长期稳居人气榜单前列。",
        ],
      },
      {
        id: "s2",
        heading: "庆祝企划",
        paragraphs: [
          "为纪念这一节点，官方将推出由作者全新绘制的纪念封面，以及一套限量周边，包括书签、亚克力立牌与明信片套装。",
          "作者也在社交平台发布手绘感谢图，向一路支持的读者致意。",
        ],
      },
      {
        id: "s3",
        heading: "后续连载",
        paragraphs: [
          "作者透露，接下来的剧情将进入备受期待的“全国大会”篇章，多位此前埋下伏笔的角色将正式登场。",
          "连载方表示会保持稳定更新节奏，并考虑推出外传短篇。",
        ],
      },
    ],
  },
  {
    id: "news-5",
    type: "news",
    title: "声优阵容公开：《机甲纪元》追加六位主要角色",
    summary:
      "《机甲纪元》官方公布追加声优名单，六位新角色的加入让主角团阵容更加完整，多段角色设定图同步解禁。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20mecha%20hangar%20with%20giant%20robot%20silhouettes%20and%20pilots%20in%20flight%20suits%2C%20dramatic%20blue%20lighting%20with%20orange%20accents%2C%20sci-fi%20anime%20key%20visual&width=800&height=500&seq=news-05&orientation=landscape",
    category: "新番情报",
    tags: ["机甲纪元", "声优", "科幻"],
    date: "2026-10-04",
    author: "星野编辑",
    popularity: 81,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "追加阵容",
        paragraphs: [
          "官方今日公布《机甲纪元》追加的六位主要角色及其配音演员，其中包括两名敌方阵营的关键人物。",
          "多位声优在采访中表示，本作的录音过程强调情绪层次，战斗戏份尤其考验爆发力。",
        ],
      },
      {
        id: "s2",
        heading: "角色设定",
        paragraphs: [
          "同步解禁的角色设定图展示了各机师专属的驾驶服与座机配色，设计上延续了系列一贯的工业感与金属质感。",
          "制作组透露，新角色将推动中盘剧情的重要转折，与主角形成鲜明的理念对立。",
        ],
      },
      {
        id: "s3",
        heading: "播出信息",
        paragraphs: [
          "《机甲纪元》目前正在热播中，官方表示后半段将进入高强度战斗篇章。",
          "相关周边与模型企划也在陆续公开，受到机设爱好者关注。",
        ],
      },
    ],
  },
  {
    id: "news-6",
    type: "news",
    title: "动画行业年度报告：流媒体成主要发行渠道",
    summary:
      "最新发布的动画行业年度报告显示，流媒体平台已成为动画作品最主要的发行渠道，海外同步播出的比例显著上升。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20glowing%20data%20streams%20and%20digital%20screens%20in%20deep%20blue%20space%2C%20abstract%20technology%20portal%20theme%2C%20clean%20modern%20composition&width=800&height=500&seq=news-06&orientation=landscape",
    category: "行业动态",
    tags: ["行业报告", "流媒体", "行业"],
    date: "2026-10-02",
    author: "编辑部",
    popularity: 73,
    format: "",
    region: "全球",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "发行格局变化",
        paragraphs: [
          "最新发布的动画行业年度报告指出，流媒体平台已经超过传统电视，成为动画作品最主要的发行渠道。",
          "报告认为，这一变化推动制作方在企划阶段就考虑全球市场的接受度。",
        ],
      },
      {
        id: "s2",
        heading: "海外同步",
        paragraphs: [
          "数据显示，海外同步播出的作品比例较去年明显上升，多语言字幕与配音的交付周期进一步缩短。",
          "与此同时，短片与竖屏内容的产量也在增长，成为新的增长点。",
        ],
      },
      {
        id: "s3",
        heading: "对创作者的影响",
        paragraphs: [
          "报告提醒，渠道多元化虽然带来更多机会，但也提高了内容在初期被注意到的难度。",
          "业内建议制作方加强前期宣传与社群运营，以积累稳定的观众基础。",
        ],
      },
    ],
  },
  {
    id: "news-7",
    type: "news",
    title: "《夜行侦探社》确定改编真人剧集",
    summary:
      "人气悬疑动画《夜行侦探社》宣布将改编为真人剧集，由原班制作团队参与监修，预计明年开拍。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20noir%20detective%20scene%20in%20rainy%20neon%20city%20at%20night%2C%20wet%20reflective%20streets%2C%20deep%20blue%20with%20warm%20accent%20lights%2C%20cinematic%20anime%20art&width=800&height=500&seq=news-07&orientation=landscape",
    category: "改编消息",
    tags: ["夜行侦探社", "真人化", "悬疑"],
    date: "2026-09-29",
    author: "小林编辑",
    popularity: 78,
    format: "",
    region: "日本",
    year: "2027",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "改编确认",
        paragraphs: [
          "官方今日确认，人气悬疑动画《夜行侦探社》将改编为真人剧集，原作编剧与动画制作团队将参与监修。",
          "制作方表示，真人化会保留原作缜密的推理结构，同时强化实景拍摄带来的临场感。",
        ],
      },
      {
        id: "s2",
        heading: "选角与制作",
        paragraphs: [
          "目前主演阵容尚未公布，官方计划在明年开拍前逐步释出选角信息。",
          "为还原作品氛围，剧组将前往多个城市进行取景，夜戏比重较高。",
        ],
      },
      {
        id: "s3",
        heading: "观众反应",
        paragraphs: [
          "消息公布后，粉丝讨论热烈，既期待实景呈现，也担心改编是否忠于原作。",
          "官方回应称将尊重原作核心，并邀请原作者深度参与剧本打磨。",
        ],
      },
    ],
  },
  {
    id: "news-8",
    type: "news",
    title: "京都动漫展公布首批参展作品名单",
    summary:
      "年度京都动漫展公布首批参展作品名单，涵盖新番、剧场版与独立动画，多场主创对谈活动同步开放预约。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20convention%20hall%20with%20glowing%20exhibition%20booths%20and%20crowd%20silhouettes%2C%20festive%20blue%20and%20amber%20lighting%2C%20illustrated%20event%20poster%20style&width=800&height=500&seq=news-08&orientation=landscape",
    category: "展会活动",
    tags: ["京都动漫展", "展会", "活动"],
    date: "2026-09-26",
    author: "特派记者",
    popularity: 69,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "首批名单",
        paragraphs: [
          "年度京都动漫展今日公布首批参展作品名单，包含多部当季新番、剧场版与独立动画短片。",
          "主办方表示，今年参展规模较去年进一步扩大，新增了创作者交流专区。",
        ],
      },
      {
        id: "s2",
        heading: "活动安排",
        paragraphs: [
          "多场主创对谈与签售活动将同步开放预约，热门场次预计很快满员。",
          "现场还设有原画展与模型展示区，供观众近距离了解制作过程。",
        ],
      },
      {
        id: "s3",
        heading: "参观提示",
        paragraphs: [
          "主办方建议观众提前在线购票并规划动线，避开高峰时段。",
          "更多参展作品与活动日程将在后续陆续公布。",
        ],
      },
    ],
  },
  {
    id: "news-9",
    type: "news",
    title: "《幻境牧场》第三季制作进行中",
    summary:
      "治愈系动画《幻境牧场》官方确认第三季正在制作，主角一家将在四季变换中迎来新的生活篇章。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20peaceful%20countryside%20ranch%20at%20golden%20hour%2C%20green%20rolling%20hills%20and%20cozy%20farmhouse%2C%20warm%20healing%20anime%20style%2C%20soft%20pastel%20tones&width=800&height=500&seq=news-09&orientation=landscape",
    category: "新番情报",
    tags: ["幻境牧场", "治愈", "新番"],
    date: "2026-09-24",
    author: "海蓝编辑",
    popularity: 66,
    format: "",
    region: "日本",
    year: "2027",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "制作确认",
        paragraphs: [
          "官方确认治愈系动画《幻境牧场》第三季正在制作中，将延续前作温馨舒缓的日常叙事。",
          "导演表示，新一季会更多聚焦家庭成员之间细腻的情感变化。",
        ],
      },
      {
        id: "s2",
        heading: "内容方向",
        paragraphs: [
          "本季将以四季变换为线索，展现牧场在春夏秋冬中的不同面貌。",
          "制作组透露会加入更多与自然相关的细节描写，强化沉浸感。",
        ],
      },
      {
        id: "s3",
        heading: "播出预期",
        paragraphs: [
          "目前官方尚未公布具体播出档期，预计于明年与观众见面。",
          "原作插画师将参与部分美术设定，保证风格的延续性。",
        ],
      },
    ],
  },
  {
    id: "news-10",
    type: "news",
    title: "独立动画短片《风与纸鸢》获国际奖项",
    summary:
      "由个人创作者完成的独立动画短片《风与纸鸢》在国际动画节中获得评审团特别奖，作品以纸鸢为线索讲述离别与重逢。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20paper%20kite%20flying%20in%20wide%20open%20sky%20above%20rolling%20fields%2C%20soft%20wind%20motion%2C%20gentle%20blue%20and%20cream%20palette%2C%20artistic%20short%20film%20style&width=800&height=500&seq=news-10&orientation=landscape",
    category: "行业动态",
    tags: ["独立动画", "奖项", "短片"],
    date: "2026-09-21",
    author: "编辑部",
    popularity: 61,
    format: "",
    region: "全球",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "获奖消息",
        paragraphs: [
          "由个人创作者完成的独立动画短片《风与纸鸢》在国际动画节中获得评审团特别奖。",
          "评审团称赞作品以极简的叙事手法传达出细腻的情感，画面充满诗意。",
        ],
      },
      {
        id: "s2",
        heading: "创作过程",
        paragraphs: [
          "作者透露，整部短片历时近两年独立完成，从分镜到上色均由一人负责。",
          "灵感来自童年放纸鸢的记忆，希望用纸鸢象征人与人之间若即若离的联系。",
        ],
      },
      {
        id: "s3",
        heading: "后续计划",
        paragraphs: [
          "作者表示会继续坚持独立创作，并尝试在下一部作品中探索新的视觉风格。",
          "短片将于下月起在多个线上平台限时公开。",
        ],
      },
    ],
  },
  {
    id: "news-11",
    type: "news",
    title: "经典作品《银河列车》宣布高清重制",
    summary:
      "陪伴一代观众的经典动画《银河列车》宣布启动高清重制，修复工作将保留原有美术风格并提升画面细节。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20retro%20space%20train%20traveling%20through%20a%20starfield%2C%20nostalgic%20cel%20animation%20aesthetic%2C%20deep%20blue%20cosmos%20with%20warm%20golden%20lights&width=800&height=500&seq=news-11&orientation=landscape",
    category: "经典重制",
    tags: ["银河列车", "重制", "经典"],
    date: "2026-09-18",
    author: "小林编辑",
    popularity: 70,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "重制启动",
        paragraphs: [
          "官方宣布经典动画《银河列车》正式启动高清重制企划，将对全片进行细致修复。",
          "修复团队表示，重制会最大程度保留原作的手绘质感，不会过度锐化或重新绘制。",
        ],
      },
      {
        id: "s2",
        heading: "修复方向",
        paragraphs: [
          "本次修复将针对胶片划痕、色彩偏移等问题逐帧处理，并重新整理音轨。",
          "同时会收录此前未公开的制作资料作为特别内容。",
        ],
      },
      {
        id: "s3",
        heading: "上映计划",
        paragraphs: [
          "重制版本计划先以限定形式在影院放映，随后推出家庭影像版本。",
          "官方希望借此让新一代观众认识这部经典作品。",
        ],
      },
    ],
  },
  {
    id: "news-12",
    type: "news",
    title: "《魔法装订社》新章连载开启",
    summary:
      "奇幻漫画《魔法装订社》开启全新章节，主角一行将踏上修复“失落的书页”的旅程，新角色同步登场。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20fantasy%20library%20interior%20with%20floating%20magic%20books%20and%20glowing%20runes%2C%20warm%20amber%20and%20deep%20blue%20lighting%2C%20magical%20manga%20illustration&width=800&height=500&seq=news-12&orientation=landscape",
    category: "连载动态",
    tags: ["魔法装订社", "漫画", "奇幻"],
    date: "2026-09-15",
    author: "海蓝编辑",
    popularity: 64,
    format: "",
    region: "日本",
    year: "2026",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "新章开启",
        paragraphs: [
          "奇幻漫画《魔法装订社》今日开启全新章节，故事围绕修复“失落的书页”展开。",
          "主角所在的装订社接到一桩神秘委托，需要前往被遗忘的书库寻找线索。",
        ],
      },
      {
        id: "s2",
        heading: "新角色登场",
        paragraphs: [
          "新章同步引入一位神秘的书籍守护者，其立场与主角团存在微妙分歧。",
          "作者表示，新角色将承担推动主线的重要作用，后续会逐步揭示其过去。",
        ],
      },
      {
        id: "s3",
        heading: "连载安排",
        paragraphs: [
          "新章将以每周更新的形式连载，单行本预计于明年春季发售。",
          "官方同步推出作品世界观设定集，收录此前未公开的魔法体系资料。",
        ],
      },
    ],
  },
];